import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import Dismissible from '../elements/Dismissible'
import GenericSelect from '../elements/forms/GenericSelect'
import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_NAME: 'Le nom ne peut pas être vide.',
  EMPTY_MANAGER: 'Veuillez choisir un responsable.'
}

class OwnerForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputName = this.onChangeInputName.bind(this)
    this.onChangeInputManager = this.onChangeInputManager.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      name: (props.data && props.data.name) || '',
      manager: (props.data && props.data.manager && props.data.manager.id) || null
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputName(name) {
    this.setInput({ name })
  }

  onChangeInputManager(manager) {
    this.setInput({ manager })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!_.isString(this.state.input.name) || this.state.input.name.length === 0) {
      formErrors.push(ERROR.EMPTY_NAME)
    }
    if (_.isNull(this.state.input.manager)) {
      formErrors.push(ERROR.EMPTY_MANAGER)
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      _.pick(this.state.input, 'name'),
      {
        manager: {
          id: this.state.input.manager
        }
      }
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Ce groupe matériel existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          <TextInput
            label='Nom'
            placeholder='Chef Mat'
            value={this.state.input.name}
            onChange={this.onChangeInputName}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_NAME)
                ? ERROR.EMPTY_NAME
                : null
            }
          />
          <GenericSelect
            label='Responsable'
            loading={this.props.usersIsFetching}
            options={
              _.isArray(this.props.usersList)
                ? _.map(this.props.usersList, (user) => ({
                    key: user.id,
                    value: user.name
                  }))
                : []
            }
            selected={this.state.input.manager}
            onChange={this.onChangeInputManager}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_MANAGER)
                ? ERROR.EMPTY_MANAGER
                : null
            }
          />
        </Form>
      </React.Fragment>
    )
  }
}

OwnerForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object,
  usersList: PropTypes.array,
  usersIsFetching: PropTypes.bool
}

export default OwnerForm



// WEBPACK FOOTER //
// ./src/components/forms/OwnerForm.js